import { Injectable } from '@angular/core';
import { Regions } from 'src/app/global/filter-options-types';
import { FilterRequests } from './filter-requests.service';
import { Country } from "../../global/types";


@Injectable({
  providedIn: 'root'
})


export class CountriesService {
  private countryOptions: Country[] = [];

  constructor(private filterRequests: FilterRequests) {}

  public async getCountries(regions: string[], divDataView: string = ""): Promise<Country[]> {
      const countries = await this.filterRequests.getCountryCodeAndNames(regions, divDataView);
      this.countryOptions = countries;
      return this.countryOptions;
  }

  public mapCountryNamesToCodes(names: string[]): string[] {
    let codes: string[] = [];
    this.countryOptions.forEach(country => {
      if (names.indexOf(country.name) > -1) {
        codes.push(country.code);
      }
    });

    return codes;
  }

  getCountryOptions(): Country[] {
    return this.countryOptions;
  }

  /**
   * Retrieves the name of a country based on its country code.
   * @param countryCode - The code of the country.
   * @returns The name of the country if found, otherwise returns the country code.
   */
  getCountryName(countryCode: string): string {
    const country = this.getCountryOptions().find(c => c.code === countryCode);
    return country ? country.name : countryCode;
  }}
